let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4emIQ")).then(() => parcelRequire('gJmwe'));